import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching line of business values failed' }))
  .then(parseAsJson);

export const fetchAccountCodes = async () => await fetch(Config.endpoints.ACCOUNTS)
  .then(handleErrors({ errorMessage: 'Fetching accounts failed' }))
  .then(parseAsJson);

export const fetchTaxDescriptionNames = async () => await fetch(Config.endpoints.FETCH_TAX_DESCRIPTION_NAMES)
  .then(handleErrors({ errorMessage: 'Fetching tax descriptions failed' }))
  .then(parseAsJson);
